<template>
    <div class="medical-column-detail-list" v-if="channelList && channelList.length">
        <van-list v-if="channelList" v-model="loading" :finished="finished" finished-text="已到底部" @load="onLoad">
            <div v-for="(item, index) in channelList" :key="item.id">
                <Lives :dataItem="item" :wapperFn="true" @goDetail="goDetail(item)" />
                <van-divider v-if="index !== channelList.length - 1" />
            </div>
        </van-list>
    </div>
</template>

<script>
import { Lives } from '@/components/contentSelection'
import Interface from '@/util/interface.js'
export default {
    components: {
        Lives
    },
    data() {
        return {
            finished: false,
            isLoading: true,
            channelList: [],
            page: {
                page: 1,
                pageSize: 10
            },
            total: 0
        }
    },
    methods: {
        onLoad() {
            this.finished = false
            this.loading = true
            this.page.page++
            this.fetch('channelList')
        },
        onRefresh() {
            this.isLoading = true
            this.page = { page: 1, pageSize: 5 }
            this.fetch('channelList')
        },
        fetch(scene) {
            if (scene === 'list') {
                Interface.getData('get', Interface.medical.followList + '607', this.page).then(res => {
                    if (!this.loading) {
                        this.channelList = res.data.list
                    } else {
                        this.channelList = [...this.channelList, ...res.data.list]
                    }
                    this.total = res.data.total
                    this.loading = false
                    this.isLoading = false

                    if (this.channelList.length >= this.total) {
                        this.finished = true
                    }
                })
            }
        }
    },
    created() {
        this.fetch('list')
    }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/live/detail_home/recommend.vue